import { http } from '@/core/api/';

const apiUrl = 'api/student';
export default {
  async getStudentHistory() {
    return http.get(`${apiUrl}/historysearch`);
  },
  getStudentDetailsBySie(sieId, syncFlag) {
    return http.get(
      `${apiUrl}/getstudentdetails?studentSie=${sieId}&syncFlag=${syncFlag}`
    );
  },
  saveHistory(sieId) {
    http.post(`${apiUrl}/savehistorysearch?studentSie=${sieId}`);
  },
  //Student SIE Information (Modal)
  getEnrollmentSchool(sieId) {
    return http.get(
      `${apiUrl}/getstudentdetailswithenrollmentSchool?studentSie=${sieId}`
    );
  },
  getStudentEnrollmentDetail(sieId) {
    return http.get(`${apiUrl}/studentenrollmentdetails?studentSie=${sieId}`);
  },
  getTherapies(sieId) {
    return http.get(`${apiUrl}/GetTherapies?studentSie=${sieId}`);
  },
  getAddress(sieId) {
    return http.get(`${apiUrl}/reloadaddressdata?studentSie=${sieId}`);
  },
  updateStatus(sieId, statusId) {
    return http.put(
      `${apiUrl}/changestatus?studentSie=${sieId}&status=${statusId}`
    );
  },
  updateMunicipality(sieId, municipalityId) {
    return http.put(
      `${apiUrl}/changemunicipality?studentSie=${sieId}&municipalityId=${municipalityId}`
    );
  },
  updateStudent(sieId) {
    return http.post(`${apiUrl}/updatestudentinfo/${sieId}`);
  },
  updateStudentImpediment(sieId) {
    return http.put(`${apiUrl}/updateimpediment/${sieId}`);
  },
};

export const getStudent = (sie) => http.get(`${apiUrl}/${sie}`);

export const replacementSieValidate = (studentSieToKeep, studentSieToDelete) =>
  http.get(
    `${apiUrl}/replacementsievalidate/${studentSieToKeep}/${studentSieToDelete}`
  );

export const replacementSie = (studentSieToKeep, studentSieToDelete) =>
  http.post(
    `${apiUrl}/replacementsie/${studentSieToKeep}/${studentSieToDelete}`
  );

export const hasSieReplacement = (studentSie) =>
  http.get(`${apiUrl}/hassiereplacement/${studentSie}`);

export const deleteSieReplacement = (studentSie) =>
  http.delete(`${apiUrl}/removesiereplacement/${studentSie}`);

export const invertSie = (studentSie) =>
  http.post(`${apiUrl}/invertSie/${studentSie}`);

export const getStudentStatuses = (statusId) =>
  http.get(`${apiUrl}/getstatuses`, {
    params: {
      statusId,
    },
  });

export const getStudentPeiHistory = (
  studentSieId,
  year = 0,
  pageNumber,
  pageSize
) =>
  http.get('/api/pei/gethistory', {
    params: {
      studentSieId,
      year,
      pageNumber,
      pageSize,
    },
  });

export const updateStudentDates = (payload) =>
  http.post(`${apiUrl}/updatedates`, payload);

export const initFilters = (params) =>
  http.get(`${apiUrl}/initfilters`, { params });
export const trackincards = (params) =>
  http.get(`${apiUrl}/trackincards`, { params });
